"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var getMetaDetailsHref = function (deepLinks, videosFirst) {
    if (videosFirst === void 0) { videosFirst = false; }
    if (!deepLinks) {
        return null;
    }
    var primaryHref = videosFirst ? deepLinks.metaDetailsVideos : deepLinks.metaDetailsStreams;
    var fallbackHref = videosFirst ? deepLinks.metaDetailsStreams : deepLinks.metaDetailsVideos;
    return typeof primaryHref === 'string' ? primaryHref : typeof fallbackHref === 'string' ? fallbackHref : null;
};
exports.default = getMetaDetailsHref;
